import React, { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { userApi } from "../../backend_urls/userApi";
import { UserURL } from "../../routes/user_routes/UserURL";
import DocumentPreview from "../../components/reusable/modals/DocumentPreview";
import InvoiceForm from "../../components/reusable/modals/InvoiceForm";
import LineItemsTable from "../../components/reusable/modals/LineItemsTable";
import InvoiceSummary from "../../components/reusable/modals/InvoiceSummary";
import ActionButtons from "../../utils/ActionButtons";
import LoadingSpinner from "../../components/loaders/LoadingSpinner";
import "../../css/pages/user_pages/InvoiceEditPage.css";

const InvoiceEditPage = () => {
    const { businessId, invoiceId } = useParams();
    const navigate = useNavigate();

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [zoom, setZoom] = useState(1);

    const isIGST = data?.invoice?.tax_type === "IGST";
    const isGST = data?.invoice?.tax_type === "CGST_SGST";

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const res = await userApi.getInvoice(invoiceId);
            setData(res);
        } catch (err) { console.error(err);
        } finally { setLoading(false); }
    }, [invoiceId]);

    useEffect(() => { fetchData(); }, [fetchData]);

    const handleChange = (field, value) => {
        setData(prev => ({ ...prev, invoice: { ...prev.invoice, [field]: value } }));
    };

    const numericFields = [
        "quantity", "rate", "taxable_value", "cgst_rate", "cgst_amount",
        "sgst_rate", "sgst_amount", "igst_rate", "igst_amount", "line_total"
    ];

    const handleItemChange = (index, field, value) => {
        setData(prev => {
            const updated = [...prev.invoice.line_items];
            updated[index] = {
                ...updated[index],
                [field]: numericFields.includes(field) ? Number(value) || 0 : value
            };
            return { ...prev, invoice: { ...prev.invoice, line_items: updated } };
        });
    };

    const addLineItem = () => {
        setData(prev => ({
            ...prev,
            invoice: {
                ...prev.invoice,
                line_items: [...prev.invoice.line_items, { description: "" }]
            }
        }));
    };

    const deleteLineItem = (index) => {
        setData(prev => ({
            ...prev,
            invoice: {
                ...prev.invoice,
                line_items: prev.invoice.line_items.filter((_, i) => i !== index)
            }
        }));
    };

    const handleSave = async () => {
        try {
            setLoading(true);
            await userApi.updateInvoice( businessId, invoiceId, data.invoice );
            alert("Invoice updated!");
            navigate(UserURL.USER_BUSINESS_HUB); 
        } catch (e) { console.error(e);
        } finally { setLoading(false); }
    };

    return ( loading ? <LoadingSpinner /> :
        <div className="invoice-container">
            <div className="invoice-left">
                <DocumentPreview
                    fileUrl = { data?.file_url }
                    zoom    = { zoom }
                    setZoom = { setZoom }
                />
            </div>

            <div className="invoice-right">
                <InvoiceForm
                    invoice      = { data?.invoice }
                    handleChange = { handleChange }
                    isIGST       = { isIGST }
                    isGST        = { isGST }
                />

                <LineItemsTable
                    items            = { data?.invoice?.line_items }
                    handleItemChange = { handleItemChange }
                    addLineItem      = { addLineItem }
                    deleteLineItem   = { deleteLineItem }
                    isIGST           = { isIGST }
                    isGST            = { isGST }
                />

                <InvoiceSummary
                    invoice = { data?.invoice }
                    isIGST  = { isIGST }
                    isGST   = { isGST }
                />

                {/* <button onClick={handleSave}>Update</button> */}\
                <br />
                <ActionButtons
                    actions={[
                        {
                            buttonType: "viewOutline",
                            customName: "Update",
                            onClick: () => handleSave,
                        }
                    ]}
                />
            </div>
        </div>
    );
};

export default InvoiceEditPage;
